
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.726 3.55A1.175 1.175 0 003.55 4.726v18.948c0 .65.526 1.176 1.176 1.176h10.2v-8.248H12.15v-3.216h2.778v-2.37c0-2.75 1.679-4.248 4.133-4.248 1.176 0 2.186.088 2.481.126V9.77H19.84c-1.335 0-1.593.634-1.593 1.565v2.052h3.183l-.414 3.216h-2.77v8.247h5.428a1.176 1.176 0 001.176-1.176V4.726a1.175 1.175 0 00-1.176-1.176H4.726z","fill":"#ACACAC"}})])
          )
        }
      }
    